import APInput, {
  APCheckbox
} from '../../../atoms/APInput';

import APLinkSent from '../../../organisms/APLinkSentPanel/APLinkSent';

import APSelect, { APSelectCombo } from '../../../atoms/APSelect';

export const COMPONENT_DEFINITIONS: any = {
  'checkbox': APCheckbox,
  'combo': APSelectCombo,
  'default': APInput,
  'select': APSelect,
  'text': APInput,
  'linkSent': APLinkSent
};
